import { Component, OnInit, inject, input } from '@angular/core';
import { GameFilterService } from '../../../../services/games/game-filter.service';
import { PlatformService } from '../../../../services/platform.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { BtnComponent } from '../../../components/btn/btn.component';
import { MultiCheckboxComponent } from '../../../../vendor/multi-checkbox/multi-checkbox.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-games-filter-bar',
  templateUrl: './games-filter-bar.component.html',
  styleUrls: ['./games-filter-bar.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgClass,
    MultiCheckboxComponent,
    BtnComponent,
    TranslatePipe,
  ],
})
export class GamesFilterBarComponent implements OnInit {
  gamesFilter = inject(GameFilterService);
  private _platform = inject(PlatformService);


  readonly isGamesFilterBarSideNav = input<boolean>(false);

  public isFirefox = false;

  ngOnInit(): void {
    if (this._platform.isBrowser) {
      this.isFirefox =
        navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }
  }

  async onSubmit() {
    if (!this.isGamesFilterBarSideNav()) {
      await this.gamesFilter.onSubmitFilter();
      this.gamesFilter.toggleSearchPopup();
    } else {
      this.gamesFilter.onSubmitSideNavFilter();
    }
  }

  public async onCancel() {
    this.gamesFilter.updateShowFiltersBar(false);
  }
}
